<template>
    <div class="container">
        <div>
            <div class="row page-content">
                <div class="col-12">
                    <h1 class="page-heading text-dark">
                        Product Gallery
                    </h1>
                </div>

                <div class="col-xxl-4 col-xl-6 col-lg-6 col-md-6 col-12 mb-4 card" v-if="products" v-for="product in products">
                    <h5>{{ product.name }} <small class="muted">/ {{ product.set_id }}</small></h5>
                    <table class="product-info">
                        <thead>
                        <tr>
                            <th>field</th>
                            <th>value</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="field in tableFields">
                            <td>{{ field }}</td>
                            <td>{{ product[field] }}</td>
                        </tr>
                        </tbody>
                    </table>
                    <div class="text-center">
                        <img v-if="product.asset_urls" v-for="productImage in product.asset_urls" :src="productImage" alt="product-image" class="product-image">

                        <div class="card-text text-center collection-info row" v-if="product.item_type !== 'single-booster'">
                            <div class="pt-0">
                                <div v-if="product.booster_count > 0 || product.included_foreign_boosters" class="collection-card-wrapper">
                                    <a href="javascript:"
                                       v-for="includedCard in product.includedCards"
                                       v-on:click="showCardCanvas(includedCard)"
                                       :style="'background-image: url('+CardService.getSmallCardImageUrl(includedCard)+')'"
                                       class="collection-card-preview">
                                    </a>

                                    <a href="javascript:"
                                       v-if="product.booster_count"
                                       :style="'background-image: url('+CardService.getRandomBoosterPackShotBySetId(product.set_id)+')'"
                                       class="collection-booster-preview">
                                                            <span class="badge">
                                                                {{ product.booster_count }}
                                                            </span>
                                    </a>

                                    <a href="javascript:"
                                       v-if="product.included_foreign_boosters"
                                       v-for="booster in product.included_foreign_boosters.split(';')"
                                       :style="'background-image: url('+CardService.getRandomBoosterPackShotBySetId(booster.split(':')[0])+')'"
                                       class="collection-booster-preview">
                                                            <span class="badge">
                                                                {{ booster.split(':')[1] ?? '' }}
                                                            </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <card-detail-view-canvas :card="promoCardToShow" :gallery="true"></card-detail-view-canvas>
    </div>
</template>


<script>
import axios from "axios";
import CardService from "../../CardService";
import CardDetailViewCanvas from "../parts/CardDetailViewCanvas.vue";

export default {
    name: "ProductGallery",
    components: {CardDetailViewCanvas},
    computed: {
        CardService() {
            return CardService
        }
    },
    data() {
        return {
            tableFields: ['id', 'name', 'item_type', 'cooldown_in_minutes', 'level_requirement', 'price', 'included_cards', 'release_date'],
            products: null,
            promoCardToShow: null
        }
    },
    mounted() {
        this.$store.commit('updateUserData');
        this.fetchProducts();
    },
    methods: {
        fetchProducts() {
            axios.get('https://dipocaco.me/api/products').then(response => {
                this.products = response.data.map(product => {
                    product.asset_urls = product.asset_url.split(';');
                    return product;
                });
            })
        },
        showCardCanvas(card) {
            this.promoCardToShow = card;
            setTimeout(() => {
                $("#card-detail-view-canvas").offcanvas('toggle');
            }, 100)
        }
    },
}
</script>

<style lang="scss" scoped>
.product-image {
    max-height: 15em;
    margin-bottom: 3em;
}

.collection-info {
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    .collection-card-wrapper {
        height: 16em;
        overflow-x: auto;
        overflow-y: hidden;
        white-space: nowrap;

        .collection-booster-preview {
            background-size: contain;
            background-repeat: no-repeat;
            display: inline-block;
            height: 14.95em;
            width: 8.6em;
            margin-left: 0.5em;
            margin-right: 0.5em;
            vertical-align: top;
            text-align: right;

            .badge {
                background-color: black;
                color: white;
                font-weight: bold;
                font-size: 1rem;
                margin-left: 0.25em;
                margin-right: 0.25em;
            }
        }

        .collection-card-preview {
            background-size: contain;
            background-repeat: no-repeat;
            display: inline-block;
            height: 15.5em;
            width: 11em;
            margin-left: 0.5em;
            margin-right: 0.5em;
        }
    }
}

.product-info {
    width: 100%;
    border: 1px solid grey !important;
    margin-bottom: 2em;

    th, td {
        border: 1px solid grey !important;
    }
}
</style>
